module.exports = __webpack_public_path__ + "static/media/background-2.d142c19a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/assets/img/background-2.jpg
// module id = 1606
// module chunks = 0